// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".list-block[data-v-39bb36e5] {\n  padding: 0px 0px 0px 0px;\n  margin: auto;\n  width: 100%;\n}", "",{"version":3,"sources":["webpack://./src/pages/user/CMChangePassword.vue"],"names":[],"mappings":"AACA;EACI,wBAAA;EACA,YAAA;EACA,WAAA;AAAJ","sourcesContent":["\n.list-block {\n    padding: 0px 0px 0px 0px;\n    margin: auto;\n    width: 100%\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
